module.exports = __webpack_public_path__ + "static/media/loading.a6b97ecb.gif";